import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { Box } from '@mui/material';
import { Dayjs } from 'dayjs';
import FormView from './form';
import SuccessView from './success';

type ExtendPolicyDialogProps = CustomDialogProps & {
  policy: PolicyModel;
  switchToPolicy: () => void;
};

const ExtendPolicyDialog = (props: ExtendPolicyDialogProps) => {
  const { close, policy, switchToPolicy } = props;
  const [step, setStep] = useState(1);
  const [submitInfo, setSubmitInfo] = useState<{ endDate: Dayjs }>();

  // confirm form success
  const confirmSuccessAction = (info) => {
    setSubmitInfo(info);
    setStep(2);
  };

  return (
    <Box>
      {step === 1 && <FormView policy={policy} submitInfo={submitInfo} close={close} confirm={confirmSuccessAction} switchToPolicy={switchToPolicy} />}
      {step === 2 && <SuccessView close={close} submitInfo={submitInfo} />}
    </Box>
  );
};

export default ExtendPolicyDialog;
